import {
  BadgePercent,
  GraduationCap,
  CreditCard,
  CircleCheck,
  ChevronRight,
} from "lucide-react";

import Accordion from "./Accordion";
import DescuentosEnlinea from "../newPages/homenew/DescuentosEnlinea";

function EnLineaPagos() {
  return (
    <>
    <DescuentosEnlinea></DescuentosEnlinea>
    </>
  );
}

export default EnLineaPagos;
